import { useRef } from "react";
import { BaseMenuItem } from "./styles";
import { MenuItemContainer, ItemLabelContainer } from "../dropdownPrimitive/DropdownItem";
import type { ItemRenderProps } from "../dropdownPrimitive/types";

const YearDropdownItem = ({
  item,
  hashFunction,
  selectedItem,
  index,
  highlightedIndex,
  getItemProps,
}: ItemRenderProps) => {
  const dropdownItemRef = useRef(null);

  return (
    <BaseMenuItem
      ref={dropdownItemRef}
      className={[
        index === highlightedIndex ? "menu-item--highlighted" : "",
        selectedItem && item.value === selectedItem.value ? "menu-item--selected" : "",
      ].join(" ").trim()}
      key={`item_${item.value}`}
      {...getItemProps({ item, index })}
    >
      <MenuItemContainer>
        <ItemLabelContainer>{hashFunction(item)}</ItemLabelContainer>
      </MenuItemContainer>
    </BaseMenuItem>
  );
};

export default YearDropdownItem;
